export interface LegalSection {
  title?: string;
  paragraphs: string[];
}

export const LEGAL_NOTICE_CONTENT: LegalSection[] = [
  {
    paragraphs: [
      "Conformément aux dispositions des articles 6-III et 19 de la Loi n° 2004-575 du 21 juin 2004 pour La Confiance dans l'Économie Numérique, dite L.C.E.N., nous portons à la connaissance des utilisateurs et visiteurs de la Plateforme les informations suivantes :",
    ],
  },
  {
    title: 'Éditeur de la Plateforme',
    paragraphs: [
      'La Plateforme est gérée par la société ADN CONFORMITÉ, Société par Actions Simplifiée Unipersonnelle immatriculée au Registre de Commerce des Sociétés de Paris, dont le siège social est basé au 9 impasse des jardiniers 75011 Paris et dont le capital social est de 1 000 € Euros.',
      'Numéro RCS : 993 392 158',
      'Numéro de TVA intra-communautaire : FR90993392158',
    ],
  },
  {
    title: 'Contact',
    paragraphs: [
      'Par mail : contact@adnconformite.com',
      'Par courrier : ADN Conformité 9 impasse des jardiniers 75011 Paris',
    ],
  },
  {
    title: 'Directeur de la publication',
    paragraphs: ['Nour HABITA'],
  },
  {
    title: 'Hébergement du site',
    paragraphs: [
      'Raison sociale : Amazon Web Services LLC (USA)',
      'Adresse : P.O. Box 81226, Seattle, WA 98108-1226',
      'Numéro SIRET : 894 775 766',
      'Numéro de téléphone : +1 206-266-1000',
    ],
  },
];
